<template>
  <!-- 카메라 대여 신청 -->
  <div>
    <v-card class="ma-4 word_keeper">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
          <v-icon class="mr-2">mdi-square-edit-outline</v-icon>카메라 대여 신청
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          {{$store.state.CustomInfo.SiteNm}} 담당자
        </v-card-subtitle>
      </v-toolbar>
      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <div class="d-flex">
                <v-text-field ref="ChargeInfoRef" v-model="zChargeInfo.cEmailAddr1" @keyup="ResetEmailInfo()" @keyup.enter="GetChargeInfo()" class="mr-2" dense persistent-placeholder>
                  <template v-slot:label>
                    담당자 이메일<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
                <v-select v-model="zChargeInfo.cEmailAddr2" :items="zEmaillAddr" @click:append-outer="GetChargeInfo()" append-outer-icon="search" auto-select-first dense style="width:160px;">
                  <template v-slot:prepend>
                    <div>@</div>
                  </template>
                </v-select>
              </div>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field v-model="zChargeInfo.cUserNm" readonly label="담당자 이름" dense persistent-placeholder></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="zChargeInfo.cUserNm" @keyup.enter="ShowDialog()" @click:append-outer="ShowDialog()" append-outer-icon="search" dense persistent-placeholder>
                <template v-slot:label>
                  담당자 이름<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>


      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          촬영자 정보
        </v-card-subtitle>
      </v-toolbar>
      <v-card outlined tile class="ma-4">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNm" label="촬영자명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Tel" label="휴대전화번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">              
                <v-text-field class="ml-0 mb-0" style="height:20px; margin-top: 3px;"
                    v-model="editedItem.cDate" dense persistent-placeholder                    
                    append-icon="mdi-calendar"
                    readonly
                    @click:append="GetDate()"
                    placeholder="촬영일">
                    <template v-slot:label>
                      <div>촬영일<strong class="red--text">*</strong></div>
                    </template>
                  </v-text-field>              
            </v-col>  
            <v-col cols="12" sm="6" md="3">
              <v-select v-model="editedItem.cStart" :items="zStart" dense persistent-placeholder @change="GetCameraList();">
                <template v-slot:label>
                  <div>대여요청시간<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-select v-model="editedItem.cEnd" :items="zEnd" dense persistent-placeholder @change="GetCameraList();">
                <template v-slot:label>
                  <div>반납예정시간<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <div v-if="zCamera.length == 0">

                <span v-if="isGetCameraList" class="text-sm-subtitle-2">사용가능한 카메라를 검색중 입니다.</span>                
                <span v-else-if="isTimeError" class="red--text text-sm-subtitle-2">유효하지 않은 대여시간입니다.</span>                
                <span v-else class="red--text text-sm-subtitle-2">선택할 수 있는 카메라가 없습니다.</span>                
              </div>
              <v-select v-else v-model="editedItem.cCameraId" :items="zCamera" dense persistent-placeholder placeholder="카메라 선택" >
                <template v-slot:label>
                  <div>카메라선택<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>


            <v-col cols="12" sm="6" md="3">
              <v-select v-model="editedItem.cPurpose" :items="zPicPurpose" dense persistent-placeholder>
                <template v-slot:label>
                  <div>촬영목적<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea ref="InfoRef" v-model="editedItem.cInfo" dense auto-grow rows="1" persistent-placeholder>
                <template v-slot:label>
                  <div>촬영내용<strong class="red--text">*</strong></div>
                </template>
              </v-textarea>
            </v-col>
            <v-col cols="4" sm="2" md="2">
              보안서약<strong class="red--text">*</strong>
            </v-col>
            <v-col cols="8" sm="10" md="10" class="caption text-sm-subtitle-2">
              <p class="mb-0">상기 신청 내용에 한하여 촬영하고, 반·출입 절차를 준수하겠으며, 회사정보의 무단 반출 등으로 인한
                <span class="red--text">일체의 책임</span>은
                <span class="red--text">신청인에게 있음</span>에 동의합니다.
              </p>
              <v-checkbox ref="AgreeRef" v-model="bAgree" style="max-width:120px;" class="ml-0" dense color="black">
                <template v-slot:label>
                  <div class="black--text">
                    동의함
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

        
      
      <v-card-text align="center">
        <v-divider class="ma-4 mr-0 ml-0"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn :disabled="zCamera.length == 0" @click="SetCameraPerLog()" dark class="ml-2" width="100px"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
      </v-card-text>
    </v-card>

    

    <v-dialog v-model="isDate" width="290px">
      <v-card style="height: 440px;">        
        <v-date-picker
          color="black" 
          show-adjacent-months
          v-model="pickerDate"
          :min="minDate"
          locale="ko"          
          :day-format="(date) => new Date(date).getDate()">
          </v-date-picker>
        <div class="d-flex ma-3 mb-5">
          <v-spacer></v-spacer>
          <v-btn @click="isDate = false">취소</v-btn>
          <v-btn class="ml-2" @click="setDate()"><v-icon>mdi-check</v-icon> 확인</v-btn>
        </div>
      </v-card>
    </v-dialog>    
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";
import Util from "../Util.js";



export default {
  components: {    
  },

  data: () => ({
    minDate: new Date().toISOString().substr(0, 10),
    isGetCameraList : false,
    isTimeError : false,
    isDate : false,
    pickerDate : "",    
    bAgree : false,    
    zStart   : [    
      {value : "08:00:00", text : "08:00"},
      {value : "08:30:00", text : "08:30"},
      {value : "09:00:00", text : "09:00"},
      {value : "09:30:00", text : "09:30"},
      {value : "10:00:00", text : "10:00"},
      {value : "10:30:00", text : "10:30"},
      {value : "11:00:00", text : "11:00"},
      {value : "11:30:00", text : "11:30"},
      {value : "12:00:00", text : "12:00"},
      {value : "13:00:00", text : "13:00"},
      {value : "13:30:00", text : "13:30"},
      {value : "14:00:00", text : "14:00"},
      {value : "14:30:00", text : "14:30"},
      {value : "15:00:00", text : "15:00"},
      {value : "15:30:00", text : "15:30"},
      {value : "16:00:00", text : "16:00"},
      {value : "16:30:00", text : "16:30"},
      {value : "17:00:00", text : "17:00"},
      {value : "17:30:00", text : "17:30"},
      {value : "18:00:00", text : "18:00"},
    ],

    zEnd   : [    
      {value : "08:00:00", text : "08:00"},
      {value : "08:30:00", text : "08:30"},
      {value : "09:00:00", text : "09:00"},
      {value : "09:30:00", text : "09:30"},
      {value : "10:00:00", text : "10:00"},
      {value : "10:30:00", text : "10:30"},
      {value : "11:00:00", text : "11:00"},
      {value : "11:30:00", text : "11:30"},
      {value : "12:00:00", text : "12:00"},
      {value : "13:00:00", text : "13:00"},
      {value : "13:30:00", text : "13:30"},
      {value : "14:00:00", text : "14:00"},
      {value : "14:30:00", text : "14:30"},
      {value : "15:00:00", text : "15:00"},
      {value : "15:30:00", text : "15:30"},
      {value : "16:00:00", text : "16:00"},
      {value : "16:30:00", text : "16:30"},
      {value : "17:00:00", text : "17:00"},
      {value : "17:30:00", text : "17:30"},
      {value : "18:00:00", text : "18:00"},
    ],


    zCamera   : [],    

    editedItem :{
      cPurpose : "0",
      cZone    : "",
      cInfo    : "",
      cDate : Util.sFormatDate(Date()),
      cStart   : "08:00:00",
      cEnd   : "18:00:00",
      cCameraId : "",
    },

    defaultItem :{
      cPurpose : "0",
      cZone    : "",
      cInfo    : "",
      cDate : Util.sFormatDate(Date()),
      cStart   : "08:00:00",
      cEnd   : "18:00:00",
      cCameraId : "",
    },

    zChargeInfo : {
      cUserId: "",
      cUserNm :  "",
      cEmailAddr1 : "",
      cEmailAddr2 : "",
    },
  }),

  computed: {
    ...mapState(["CustomInfo","zPicPurpose","zEmaillAddr"]),
  },

  created() {
  },

  mounted() {    
    this.init();
  },

  methods : {
    ResetEmailInfo(){
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
    },

    GetDate() {      
      this.isDate = true;
      this.pickerDate = this.editedItem.cDate;
    },

    setDate(){
      this.isDate = false;
      this.editedItem.cDate = this.pickerDate;

      this.GetCameraList();
    },

    init() {
      this.editedItem  = Object.assign({}, this.defaultItem);
      this.zChargeInfo.cEmailAddr1 = ""
      this.zChargeInfo.cEmailAddr2 = this.zEmaillAddr[0]
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
      
      this.bAgree = false;

      setTimeout(() => {
        this.GetCameraList();
      }, 100);
    },


    GetCameraList(){
      this.zCamera = [];
      this.isTimeError = true;
      if (this.editedItem.cStart >= this.editedItem.cEnd){        
        return
      }

      this.isTimeError = false;
      this.isGetCameraList = true;
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,        
        cStartDateTime : this.editedItem.cDate + " " + this.editedItem.cStart,
        cEndDateTime : this.editedItem.cDate + " " + this.editedItem.cEnd,        
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetCameraList", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          this.isGetCameraList = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {            
            this.zCamera = res.data.Result;

            if (this.zCamera.length > 0) {              
              this.editedItem.cCameraId = this.zCamera[0].value;
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          this.isGetCameraList = false;
          EventBus.$emit("onShowMsg",true, "GetCameraList:"+err);        
        });
    },

    
    GetChargeInfo(){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        Email : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetChargeInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              EventBus.$emit("onShowMsgBox","입력하신 이메일을 다시 확인하여 주세요.","입력하신 이메일과 일치하는 담당자가 없습니다.");
            } else {
              this.zChargeInfo.cUserId = res.data.Result[0].cUserId
              this.zChargeInfo.cUserNm = res.data.Result[0].cUserNm
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    //  카메라 대여 신청하기
    SetCameraPerLog(){      
      if (this.zChargeInfo.cUserId == ""){
        EventBus.$emit("onShowMsgBox", "담당자가 선택 되지 않았습니다.","검색 아이콘을 클릭 하여 담당자를 검색 및 선택하여 주세요.");

        this.$refs.ChargeInfoRef.focus();
        return
      }

      if (this.editedItem.cCameraId == ""){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "카메라를 선택해주세요.");        
        return
      }

      if (this.editedItem.cPurpose == null){        
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 목적을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cInfo == ""){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 내용을 입력하여 주세요.");
        this.$refs.InfoRef.focus();
        return
      }

      if (this.bAgree == false){
        EventBus.$emit("onShowMsgBox","보안서약에 대한 동의","보안서약에 동의해 주세요.");
        this.$refs.AgreeRef.$el.querySelector('input').focus();
        return
      }



      if (this.editedItem.cStart >= this.editedItem.cEnd){
        EventBus.$emit("onShowMsgBox", "확인", "카메라 대여 시간을 확인해주세요.");
        return
      }


      var posData = {        
        CameraRentId : "",
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        UserId : this.zChargeInfo.cUserId,
        ChargeEmail : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,        
        cStartDateTime : this.editedItem.cDate + " " + this.editedItem.cStart,
        cEndDateTime : this.editedItem.cDate + " " + this.editedItem.cEnd,       
        CameraId : this.editedItem.cCameraId,
        Purpose : this.editedItem.cPurpose,
        Info : this.editedItem.cInfo,        
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetCameraPerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.init();
            EventBus.$emit("onShowMsg",false,  "카메라 대여 신청이 완료되었습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        // .catch(err => {
        //   EventBus.$emit("onShowMsg",true, ""+err);        
        // });
    },
  }
}
</script>

<style>
</style>